/* Package JSON Import will be here */
import React, { Fragment } from "react";
import { Table, Pagination, Button, Modal, Grid, Search } from 'semantic-ui-react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Constants } from '../../../../src/config/appConstants';
import NoResultFound from "../../sharedComponent/noResultFound";
import AttachmentViewer from "../../sharedComponent/attachmentViewer/attachmentViewer.Container";
import "../timeCard.css";
/* Project Import will be here */

const TimeCardIssueComponent = props => {
    return (
        <Fragment>
            <Modal
                open={props.timeCardIssue.isModalVisible}
                onOpen={props.openModal}
                onClose={() => props.closeModal()}
                size='large'
                closeIcon
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header className="headerColor text-color">Issue Notes for All Projects</Modal.Header>
                <Modal.Content scrolling>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16} className="topSerachDate">
                                <Search className="searchWidth" onSearchChange={props.onIssueSearch} placeholder={Constants.SEARCH_PLACEHOLDER} />
                                <div className="timeCardDate">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                        <KeyboardDatePicker
                                            placeholder="MM/dd/yyyy"
                                            value={props.timeCardIssue.selectedDate}
                                            onChange={date => props.handleDateChange(date)}
                                            inputProps={{ readOnly: true }}
                                            format="MM/dd/yyyy"
                                            disableFuture={true}
                                            {...(props.timeCardIssue.minimumDate ? { minDate: props.timeCardIssue.minimumDate } : {})}
                                            {...(props.timeCardIssue.maximumDate ? { maxDate: props.timeCardIssue.maximumDate } : {})}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Table celled padded striped>
                        <Table.Header className="header-bg" style={{ size: 'small' }}>
                            <Table.Row>
                                <Table.HeaderCell >
                                    Project Number
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Device Name
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Issue Notes
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Status Code
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Lost Hours
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Attachments
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body className="noData">
                            {props.timeCardIssue.issueNotes && props.timeCardIssue.issueNotes.length > 0 ? props.timeCardIssue.issueNotes.map(({ deviceEmpID, issueNote, projectNumber, id, deviceID, attachments, submittedDeviceName, fieldStatusDescription, lostHours }) => (
                                <Table.Row key={`${id}-${deviceID}`}>
                                    <Table.Cell>{projectNumber}</Table.Cell>
                                    <Table.Cell style={{ wordBreak: 'break-all' }}>{submittedDeviceName !== null ? submittedDeviceName : ""}</Table.Cell>
                                    <Table.Cell className="issueNotes">{issueNote}</Table.Cell>
                                    <Table.Cell className="statusDescription"><div>{fieldStatusDescription}</div></Table.Cell>
                                    <Table.Cell>{lostHours}</Table.Cell>
                                    <Table.Cell>{attachments && attachments.length > 0 && attachments.map(attach => {
                                        return (<img className="imgClass" alt={attach.attachmentName} src={Constants.DATA_BASE64 + attach.attachmentContent} onClick={() => props.openAttachmentViewer(attach)} />)
                                    })}</Table.Cell>
                                </Table.Row>
                            )) :
                                <Table.Row style={{ width: '100%' }}>
                                    <Table.Cell colSpan="6">
                                        <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                    </Table.Cell>
                                </Table.Row>
                            }
                        </Table.Body>
                        {props.timeCardIssue.issueNotes && props.timeCardIssue.issueNotes.length > 0 && <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan='16'>
                                    <Pagination floated="right"
                                        activePage={props.timeCardIssue.pagination.activePage}
                                        onPageChange={props.paginationChange}
                                        ellipsisItem={null}
                                        firstItem={null}
                                        lastItem={null}
                                        totalPages={props.timeCardIssue.pagination.totalCount}
                                    />
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                        }
                    </Table>
                </Modal.Content>
                <Modal.Actions>
                    <Button secondary className="backButtonSpacing" type="button" primary onClick={() => props.closeModal()}>Back</Button>
                </Modal.Actions>
            </Modal>
            {props.timeCardIssue.isAttachmentModelVisible &&
                <AttachmentViewer attachmentName={props.timeCardIssue.selectedAttachment.attachmentName} attachmentContent={props.timeCardIssue.selectedAttachment.attachmentContent} closeAttachmentViewer={props.closeAttachmentViewer} />
            }
        </Fragment>
    );
}

export default TimeCardIssueComponent;

TimeCardIssueComponent.displayName = "TimeCardIssueComponent";